// layouts/AuthLayout.js
import { Outlet } from 'react-router-dom';

const AuthLayout = () => (
  <div style={{ padding: '40px', maxWidth: '400px', margin: '0 auto' }}>
    <Outlet />
  </div>
);

export default AuthLayout;
